import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"menu\">\r\n<title>menu</title>\r\n<path d=\"M0.082 4.242h31.683v4.752h-31.683v-4.752z\" />\r\n<path d=\"M0.083 22.953l31.683-0.036 0.005 4.752-31.683 0.036-0.005-4.752z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol